import Vue from 'vue';
import Router from 'vue-router';

import LandingPage from '../components/LandingPage';
import Home from '../components/Home';
import Account from '../components/Account';
import Market from '../components/Market';
import Settings from '../components/Settings';
import FAQ from '../components/FAQ';

import MySprites from '../components/mysprites/MySprites';
import SpritePage from '../components/monsters/SpritePage';

import EventCreate from '../components/events/EventCreate';
import EventDetail from '../components/events/EventDetail';

import HabiticaLogin from '../components/auth/HabiticaLogin';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login-habitica',
      name: 'HabiticaLogin',
      component: HabiticaLogin,
    },
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/create-event',
      name: 'EventCreate',
      component: EventCreate,
    },
    {
      path: '/events/:eventId',
      name: 'EventDetail',
      component: EventDetail,
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
    },
    {
      path: '/market',
      name: 'Market',
      component: Market,
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ,
    },
    {
      path: '/sprites',
      name: 'MySprites',
      component: MySprites,
    },
    {
      path: '/sprites/:spriteId',
      name: 'SpritePage',
      component: SpritePage,
    },
  ],
});

let userIsLoggedIn = false;

router.beforeEach((to, from, next) => {
  const { name } = to;

  if (!userIsLoggedIn) {
    const storedUser = localStorage.getItem('habitica-token-user');
    if (storedUser) userIsLoggedIn = true;
  }

  if (name !== 'HabiticaLogin' && name !== 'LandingPage' && !userIsLoggedIn) {
    next({ name: 'HabiticaLogin', query: to.query });
    return;
  }

  if (name === 'LandingPage' && userIsLoggedIn) {
    next({ name: 'Home', query: to.query });
    return;
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js